import type { ChipTone, IconName } from '@dataroom/shared';

// Active / Archived / In Trash. Legacy `draft` / `closed` rows render as
// Active / Archived (see RoomConfigCard).
export const LIFECYCLE_LABELS: Record<string, string> = {
  draft: 'Active',
  active: 'Active',
  archived: 'Archived',
  closed: 'Archived',
  trashed: 'In Trash',
};

/** The lifecycle chip (word + icon + colour): Active reads as healthy, Archived
 * neutral, In Trash as an error. */
export function lifecycleChip(state: string): { tone: ChipTone; icon: IconName } {
  switch (state) {
    case 'archived':
    case 'closed':
      return { tone: 'neutral', icon: 'archive' };
    case 'trashed':
      return { tone: 'error', icon: 'trash' };
    default:
      return { tone: 'certified', icon: 'check' };
  }
}

/** Router location state handed to a room on arrival. `setupChecklist` (set by
 * room creation) opens the checklist-source dialog once. */
export interface RoomLocationState {
  setupChecklist?: boolean;
  /** One-shot, for the Checklist tab: show the phase plan with its first date
   * focused (after "Release Phase 1 to the seller now?" → Yes). */
  focusPhaseDates?: boolean;
}
